import { Row } from '../../lib/utils';
import { Head4 } from '../../lib/font';
import { colors } from '../../lib/colors';
import SvgIcon from '../SvgIcon';

type Props = {
    onClickBackButton: () => void;
};

const DetailHeader = ({ onClickBackButton }: Props) => {
    return (
        <Row
            style={{
                alignItems: 'center',
                width: 1192,
                marginTop: 38,
                marginBottom: 36,
            }}
        >
            <div
                className="flex flex-row items-center cursor-pointer transition-opacity duration-200 hover:opacity-70"
                onClick={onClickBackButton}
            >
                <div className="flex items-center mr-[16px]">
                    <SvgIcon
                        name="SvgLeftStrokeArrow"
                        stroke={colors.LAVEL_4}
                        size={20}
                        fill="none"
                    />
                </div>
                <Head4 style={{ color: colors.LAVEL_4 }}>강사 프로필</Head4>
            </div>
        </Row>
    );
};

export default DetailHeader;
